import { motion, useAnimation } from "framer-motion";
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import React, { useEffect } from "react";

import * as styles from "./styles.module.css";

const Quote = ({
  children,
  title,
  subhead,
  author,
  authorsub,
  image,
  imageLarge,
  alt,
}) => {
  const images = withArtDirection(getImage(image), [
    {
      media: "(min-width: 992px)",
      image: getImage(imageLarge),
    },
  ]);

  const controls = useAnimation();

  useEffect(() => {
    controls.start({ opacity: [0, 1], y: [120, 0] });
  }, [controls, children, title, subhead, author, authorsub]);

  const noInfo = !title && !subhead && !author && !authorsub;

  return (
    <div className={`${styles.quote} ${noInfo ? null : styles.gradient}`}>
      <GatsbyImage image={images} alt={alt} className={styles.artDirected} />
      <motion.div
        initial={{ opacity: 0, y: 120 }}
        animate={controls}
        transition={{ duration: 0.4 }}
        className={`${noInfo ? null : styles.text}`}
      >
        <div className={styles.title}>{title}</div>
        {title ? <div className={styles.line}></div> : null}
        <div className={styles.subhead}>{subhead}</div>
        <div className={styles.children}>{children}</div>
        {author && (
          <div>
            – {author} <span className={styles.author}>{authorsub}</span>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default Quote;
